import React, { useEffect, useState } from "react";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import { useAuth } from "../../../providers/authprovider";

export default function RajcompanyDeleteModal({ show, company, onHide, onDeleted }) {
  const { rajcompanies } = useAuth();
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) return;

    setDeleting(false);
    setError("");
  }, [show, company]);

  const handleClose = () => {
    if (deleting) return;

    onHide();
  };

  const handleDelete = () => {
    setDeleting(true);
    setError("");

    rajcompanies.remove(company.id, ({ success, error }) => {
      setDeleting(false);

      if (!success) {
        setError(error);
        return;
      }

      onDeleted(company.id);
      onHide();
    });
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton={!deleting}>
        <Modal.Title>Usuń spółkę</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>Czy na pewno chcesz usunąć spółkę?</div>
        <div className="text-muted small mt-2">{company.full_name}</div>

        {error && (
          <Alert variant="danger" className="mt-3 mb-0">
            {error}
          </Alert>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={deleting}>
          Anuluj
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={deleting}>
          {deleting && <Spinner size="sm" className="me-2" />}
          Usuń
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
